// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".components-Checkbox__Checkbox--soFSJ {\n    display: inline-flex;\n    align-items: center;\n    gap: 0.5rem;\n}\n\n.components-Checkbox__Checkbox--soFSJ:hover{\n    cursor:grabbing\n}", "",{"version":3,"sources":["webpack://./src/frontend/components/Checkbox.css"],"names":[],"mappings":"AAAA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI;AACJ","sourcesContent":[".Checkbox {\n    display: inline-flex;\n    align-items: center;\n    gap: 0.5rem;\n}\n\n.Checkbox:hover{\n    cursor:grabbing\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"Checkbox": "components-Checkbox__Checkbox--soFSJ"
};
export default ___CSS_LOADER_EXPORT___;
